/**
 * Matches the values returned by /order/availabilities endpoint
 */
export const ORDER_AVAILABILITY_STATUS = {
  CAN_ORDER: 'can_order',
  CAN_ORDER_MORE: 'can_order_more',
  CANNOT_ORDER: 'cannot_order',
};
